export default {
  simplePlural: (num, string) => `${string}${num === 1 ? '' : 's'}`,
}